import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=3d3b49b9&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"
import style0 from "./Awards.vue?vue&type=style&index=0&id=3d3b49b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3b49b9",
  null
  
)

export default component.exports